import React, { Fragment, useState, useEffect } from 'react';
import { Button, Modal, Spinner, Table } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ModalCloseShift({ id, title, showProps, funcClose }) {
  const [showSpinner, setshowSpinner] = useState(false);
  const [dataReport, setDataReport] = useState({
    start_value: 0,
    shift_id: 0,
    total_incoming: 0,
    total_outcoming: 0,
    net_total: 0
  });

  const localFuncClose = () => {
    funcClose();
    setshowSpinner(false);
  };

  useEffect(() => {
    const getCashiers = async () => {
      setshowSpinner(true)
      const respoCashiers = await get(`/cash/movements/report/${id}`, {});
      if (respoCashiers.success) {
        console.log(respoCashiers)
        setDataReport(respoCashiers.data)
        setshowSpinner(false)
      }
    }
    if (showProps) getCashiers();
  }, [id, showProps]);

  // <int:shift_id>
  return (
    <>
      <Modal animation={false} show={showProps} onHide={funcClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!showSpinner ? (
            <Table striped bordered hover className="mb-0">
              <thead>
                <tr>
                  <th>Monto Inicial</th>
                  <th>Total Ingresos</th>
                  <th>Total Salidas</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>${dataReport.start_value}</td>
                  <td>${dataReport.total_incoming}</td>
                  <td>${dataReport.total_outcoming}</td>
                  <td>${dataReport.net_total}</td>
                </tr>
              </tbody>
            </Table>
          ) : (
            <Spinner animation="border" role="status" variant="danger">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Fragment>
            <Button variant="secondary" onClick={localFuncClose}>
              Cerrar
            </Button>
          </Fragment>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalCloseShift;
